function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from 'react';
import { Input } from 'native-base';
import FormatWithMask from './FormatWithMask';
export default /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function (props, ref) {
  const {
    mask,
    value,
    onChangeText,
    obfuscationCharacter = 'X',
    showObfuscatedValue,
    selection,
    ...rest
  } = props;

  //   const { isOpen, onToggle } = useDisclose(false);

  const maskArray = useMemo(() => typeof mask === 'function' ? mask(value) : mask, [mask, value]);
  const formattedValueResult = React.useMemo(() => {
    return FormatWithMask({
      text: value || '',
      mask,
      obfuscationCharacter
    });
  }, [mask, obfuscationCharacter, value]);
  const maskHasObfuscation = React.useMemo(() => maskArray && !!maskArray.find(maskItem => Array.isArray(maskItem)), [maskArray]);
  const isValueObfuscated = React.useMemo(() => !!maskHasObfuscation && showObfuscatedValue, [maskHasObfuscation, showObfuscatedValue]);
  const handleChangeText = React.useCallback(text => {
    let textToFormat = text;
    if (isValueObfuscated) {
      textToFormat = formattedValueResult.masked || '';
      if (textToFormat.length > text.length) {
        textToFormat = textToFormat.slice(0, -1);
      } else if (!textToFormat) {
        textToFormat = text;
      } else {
        textToFormat = textToFormat + text[text.length - 1];
      }
    }
    const result = FormatWithMask({
      text: textToFormat,
      mask,
      obfuscationCharacter
    });
    onChangeText && onChangeText({
      masked: result.masked,
      unmasked: result.unmasked,
      obfuscated: result.obfuscated
    });
  }, [isValueObfuscated, mask, obfuscationCharacter, onChangeText, formattedValueResult.masked]);
  const inputValue = showObfuscatedValue ? formattedValueResult.obfuscated : formattedValueResult.masked;
  return /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    ref: ref,
    value: inputValue,
    selection: isValueObfuscated ? {
      start: inputValue.length,
      end: inputValue.length
    } : selection,
    height: 12.5,
    color: 'text.running',
    placeholderTextColor: 'text.running',
    onChangeText: handleChangeText
  }));
}));

//   InputRightElement={
//     showObfuscatedValue ? (
//       <Pressable px={2} onPress={onToggle}>
//         {!isOpen ? <Icon as={EyeHide} /> : <Icon as={EyeShow} />}
//       </Pressable>
//     ) : (
//       <Box />
//     )
//   }
//# sourceMappingURL=MaskedInput.js.map